import React, { useEffect, useState, useRef } from "react";
import "./WelcomeComponent.css";
import txtIndicator from '../../assets/text-indicator.svg';
import { useGameContext } from '../GameContext';
import { ANIMATIONS } from "../../utils/constants";
import soundTrackRanking from "../../assets/audios/SoundTrack.mp3";


const WelcomeComponent = ({ playAnimation }) => {
  const { user, game, socket, room } = useGameContext();
  const [currentPhrase, setCurrentPhrase] = useState(0);

  const audioRef = useRef(null); // Referencia para el audio

  useEffect(() => {
    const savedMuted = localStorage.getItem("isMuted");
    const isMutedFromStorage = savedMuted === "true";
  
    if (audioRef.current) {
      audioRef.current.muted = isMutedFromStorage;
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "isMuted" && audioRef.current) {
        audioRef.current.muted = event.newValue === "true";
      }
    };
  
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  /**
   * 
   * Formato para el array de frases:
   * 
   * [ "Frase a mostrar", tiempo en segundos, animación a mostrar ]
   * 
   * la animacion es opcional si no se especifica se reproduce la animacion de "hablando" normal.
   * 
   * SIEMPRE dejen una linea vacia al comienzo del array con un segundo para dar tiempo a la
   * cortina de quitarse y para que la segunda animacion se reproduzca correctamente.
   */

  const phrases = [
    ["", 1],
    ["¡Hola soy SAM!", 3, ANIMATIONS.hello],
    [
      game.moduleName
        ? "Bienvenido al módulo " + game.moduleName
        : "Bienvenido a este módulo viajero",
      4,
    ],
    ["¡Es hora de aprender jugando!", 3,],
    ["Empezaremos en breve", 4, ANIMATIONS.hello],
  ];
  //1 + 3 + 4 + 3 + 4 = 15 segundos para el estado de Welcome

  function nextLine(phraseIndex) {
    // If we've reached the last phrase, stop.
    if (phraseIndex >= phrases.length - 1) {
      return;
    }

    const newPhrase = phraseIndex + 1;
    const delayInSeconds = phrases[newPhrase][1];

    // Update the phrase.
    setCurrentPhrase(newPhrase);
    playAnimation(phrases[newPhrase][2]);

    // Schedule the next update using the new phrase index.
    setTimeout(() => nextLine(newPhrase), delayInSeconds * 1000);
  }

  const t = useRef(null);

  useEffect(() => {
    if (t.current) return;
    // Start after a delay that gives the first phrase extra time.
    playAnimation(phrases[0][2]);
    const initialDelay = phrases[0][1] * 1000;
    t.current = setTimeout(() => {
      nextLine(0);
    }, initialDelay);
  }, []);

  return (
    <><audio ref={audioRef} autoPlay controls loop style={{
      position: 'absolute',
      "z-index": 100,
      opacity: 0
    }}>
      <source src={soundTrackRanking} type="audio/mp3" />
    </audio><div className="TextboxContainer marginEnd">
        <div className="Textbox">
          <label>{phrases[currentPhrase][0]}</label>
          <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
        </div>
      </div></>
  );
};

export default WelcomeComponent;
